<template>
  <div>
    <Toolbar classes="pt-3">
      <template v-slot:actions>
        <div class="d-flex align-items-center">
          <router-link to="/subscription" class="btn btn-sm btn-primary">
            <i class="bi bi-arrow-left me-1"></i>
            Voltar
          </router-link>
        </div>
      </template>
    </Toolbar>
    <div class="container-xxl">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Extrato de pagamentos</h3>
        </div>
        <div class="card-body table-responsive">
          <table class="table table-row-bordered">
            <thead>
              <tr>
                <th>Data</th>
                <th>Descrição</th>
                <th>Tipo</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="payment in payments" :key="payment.id_place_platform_payment">
                <td>{{ formatDate(payment.paid_at) }}</td>
                <td>{{ payment.description }}</td>
                <td>{{ eventTypeLabel(payment.event_type) }}</td>
                <td>R$ {{ formatMoney(payment.amount) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Toolbar from '../../components/layouts/auth/Toolbar.vue';
import http from '../../helpers/http';
import Permission from '../../helpers/permission';
import moment from 'moment';

export default {
  name: 'SubscriptionStatement',
  components: { Toolbar },
  data() {
    return { payments: [] };
  },
  created() {
    if (!Permission.has('View Place Platform Subscription')) {
      this.$router.replace('/dashboard');
      return;
    }
    const placeId = this.$store.state.auth.place?.id_place;
    http.get(`/places/${placeId}/platform-subscription/payments`).then((res) => {
      this.payments = res.data;
    });
  },
  methods: {
    formatDate(value) {
      if (!value) {
        return '—';
      }

      return moment(value).format('DD/MM/YYYY HH:mm');
    },
    eventTypeLabel(type) {
      const labels = {
        payment: 'Pagamento',
        refund: 'Estorno',
        manual_adjustment: 'Ajuste manual',
      };

      return labels[type] || type;
    },
    formatMoney(value) {
      return Number(value).toFixed(2).replace('.', ',');
    },
  },
};
</script>
